<template>
  <v-autocomplete
    v-model="boatItem"
    :label="
      $t('components.checklists.checklistBoatItemSelector.selectBoatPart')
    "
    :items="boatItemOptions"
    :menu-props="{ maxHeight: '400' }"
    :search-input.sync="boatItemSearch"
    persistent-hint
    color="primary"
    clearable
    autocomplete="off"
    hide-no-data
    hide-selected
    return-object
    class="mt-0 pt-0 mb-0 pb-0"
    :disabled="disabled"
  >
    <template v-slot:item="{ item }">
      <span>
        {{ item.formatted_name }} <span v-if="item.sku">#{{ item.sku }}</span>
      </span>
    </template>
    <template v-slot:selection="{ item }">
      <span>
        {{ item.formatted_name }} <span v-if="item.sku">#{{ item.sku }}</span>
      </span>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  props: {
    checklist: { type: Object, default: Object },
    disabled: {
      type: Boolean,
      default: true,
    },
    boatUuid: {
      type: String,
      default: String,
    },
  },
  data: () => ({
    boatItemOptions: [],
    boatItemSearch: "",
    boatItem: null,
  }),
  created() {
    this.boatItemOptions.push(this.checklist.crm_boat_item.crm_item);
    this.boatItem = this.checklist.crm_boat_item.crm_item;
  },
  methods: {},
};
</script>
